import { all } from "axios";
import React, { useEffect, useState } from "react";

export default function QuoteQuickViewProducts({ selected }) {
  /*   All States
   ********************************************* */
  const [allProducts, setAllProducts] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  /*   All Functions
   ********************************************* */
  const previousProduct = () => {
    if (allProducts && selectedProduct) {
      let currentIndex = allProducts.findIndex(
        (item) => item.id === selectedProduct.id
      );
      if (currentIndex > 0) {
        let previousItem = allProducts[currentIndex - 1];
        setSelectedProduct(previousItem);
      }
    }
  };
  const nextProduct = () => {
    if (allProducts && selectedProduct) {
      let currentIndex = allProducts.findIndex(
        (item) => item.id === selectedProduct.id
      );
      if (currentIndex < allProducts.length - 1) {
        let nextItem = allProducts[currentIndex + 1];
        setSelectedProduct(nextItem);
      }
    }
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    if (selected && selected?.quoteProducts) {
      setAllProducts(selected.quoteProducts);
      setSelectedProduct(selected.quoteProducts[0]);
    }
  }, [selected]);

  if (!selected || !allProducts || allProducts.length === 0) {
    return (
      <div
        className="text-center d-flex flex-column justify-content-center align-items-center"
        style={{ height: "204px" }}
      >
        <p className="text-muted">No products available for this quote.</p>
      </div>
    );
  }

  return (
    <div>
      {/* Quote Products */}
      <div className="d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Quote Products</h4>
        <div className="d-flex align-items-center mb-1">
          {/* Product Arrow Buttons */}
          <div className="d-flex justify-content-between align-items-center gap-1">
            <button
              onClick={() => previousProduct()}
              className={"btn btn-success btn-sm p-0 px-1 "}
              disabled={
                allProducts?.length === 0 ||
                allProducts?.length === 1 ||
                (allProducts && allProducts[0]?.id === selectedProduct?.id)
              }
            >
              <i className="mdi mdi-arrow-left-bold fs-4 py-0 my-0"></i>
            </button>
            <button
              onClick={() => nextProduct()}
              disabled={
                (allProducts &&
                  allProducts[allProducts?.length - 1].id ===
                    selectedProduct?.id) ||
                allProducts?.length === 1 ||
                allProducts?.length === 0
              }
              className={"btn btn-success btn-sm p-0  px-1"}
            >
              <i className="mdi mdi-arrow-right-bold fs-4 py-0 my-0"></i>
            </button>
          </div>
        </div>
      </div>
      <hr className="mt-0" />
      {/* Description */}
      <div className="row">
        <div className="col-md-4">Description</div>
        <div className="col-md-8">{selectedProduct?.description}</div>
      </div>
      {/* Style No */}
      <div className="row">
        <div className="col-md-4">Style No</div>
        <div className="col-md-8">{selectedProduct?.styleNo}</div>
      </div>
      {/* Fabric */}
      <div className="row">
        <div className="col-md-4">Fabric</div>
        <div className="col-md-8">{selectedProduct?.fabric}</div>
      </div>
      {/* Color */}
      <div className="row">
        <div className="col-md-4">Color</div>
        <div className="col-md-8">{selectedProduct?.color}</div>
      </div>
      {/* Price */}
      <div className="row">
        <div className="col-md-4">Price</div>
        <div className="col-md-8">{selectedProduct?.price}</div>
      </div>
      {/* Quantity */}
      <div className="row">
        <div className="col-md-4">Quantity</div>
        <div className="col-md-8">{selectedProduct?.quantity}</div>
      </div>
      {/* Total */}
      <div className="row">
        <div className="col-md-4">Total</div>
        <div className="col-md-8">
          {selectedProduct?.price && selectedProduct?.quantity
            ? (selectedProduct.price * selectedProduct.quantity).toFixed(2)
            : "0.00"}
        </div>
      </div>
    </div>
  );
}
